import { useEffect, useState } from 'react'
import { apiJson } from '../../lib/api'
import { ui } from './shared'

interface Row { section: string; enabled: number }

const labels: Record<string, string> = {
  hero: 'Hero', identita: 'Identità', singoli: 'Singoli', videos: 'Video',
  gallery: 'Gallery', repertorio: 'Repertorio', date_live: 'Date live', contatti: 'Contatti',
}

const order = ['hero', 'identita', 'singoli', 'videos', 'gallery', 'repertorio', 'date_live', 'contatti']

export function SectionsEditor() {
  const [map, setMap] = useState<Record<string, boolean>>({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    apiJson<{ sections: Row[] }>('/api/admin/sections')
      .then((r) => {
        const m: Record<string, boolean> = {}
        for (const k of order) m[k] = true
        for (const row of r.sections) m[row.section] = row.enabled === 1
        setMap(m)
      })
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false))
  }, [])

  async function toggle(key: string, next: boolean) {
    setMap((m) => ({ ...m, [key]: next }))
    try {
      await apiJson(`/api/admin/sections/${key}`, {
        method: 'PUT',
        body: JSON.stringify({ enabled: next }),
      })
    } catch (err) {
      setError(String(err))
      setMap((m) => ({ ...m, [key]: !next }))
    }
  }

  if (loading) return <div style={{ color: 'var(--fg-muted)' }}>Carico…</div>

  return (
    <div>
      <h1 style={ui.sectionTitle}>Sezioni della homepage</h1>
      <p style={{ fontSize: 14, color: 'var(--fg-muted)', marginBottom: 18, maxWidth: 560 }}>
        Disattiva per nascondere l'intera sezione dal sito pubblico. I contenuti non vengono cancellati — puoi riattivarla in qualsiasi momento.
      </p>
      <div style={{ ...ui.card, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {order.map((key) => (
          <label key={key} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '10px 0', borderBottom: '1px solid var(--line)',
          }}>
            <span style={{
              fontFamily: 'var(--font-display)', textTransform: 'uppercase',
              letterSpacing: '0.04em', fontSize: 15,
            }}>{labels[key]}</span>
            <span style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <span style={{
                fontFamily: 'var(--font-body)', fontSize: 11,
                letterSpacing: '0.2em', textTransform: 'uppercase',
                color: map[key] ? 'var(--accent)' : 'var(--fg-soft)',
              }}>{map[key] ? 'visibile' : 'nascosta'}</span>
              <input type="checkbox" checked={Boolean(map[key])}
                     onChange={(e) => toggle(key, e.target.checked)} />
            </span>
          </label>
        ))}
      </div>
      {error && <div style={{ color: '#a33', marginTop: 12 }}>{error}</div>}
    </div>
  )
}
